import { useState, useEffect } from "react";
import AgentsService from "../../services/AgentsService/AgentsService.ts";
import { useAuth } from "../../provider/AuthProvider.tsx";
import SelectGroup from "../../components/Forms/SelectGroup/SelectGroup.tsx";
import { normalizeAgentProperties } from "../../utils/NormalizationUtil.ts";
import { Agent } from "../../types/agent.ts";

interface RemoveAgentPopupProps {
  officeName: string;
  agentsIds: string[];
  onClose: () => void;
  onSave: (updatedAgents: string[]) => void;
}

const RemoveAgentPopup = ({
  onClose,
  onSave,
  agentsIds,
  officeName,
}: RemoveAgentPopupProps) => {
  const { jwt } = useAuth();
  const [agents, setAgents] = useState<{ [key: string]: string }>({});
  const [selectedAgent, setSelectedAgent] = useState<string | null>(null);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const agentsData = await Promise.all(
          agentsIds.map(
            async (id): Promise<Agent> =>
              normalizeAgentProperties(
                (await AgentsService.getAgentById(jwt, id)) as object,
              ),
          ),
        );
        const agentsToKeyValuePair = agentsData.reduce(
          (acc, agent) => {
            acc[agent.agentID] = agent.agentName;
            return acc;
          },
          {} as { [key: string]: string },
        );

        setAgents(agentsToKeyValuePair);
      } catch (error) {
        throw new Error("Грешка при зареждането на агенти");
      }
    };
    fetchAgents();
  }, [jwt, agentsIds]);

  const handleAgentRemoval = () => {
    if (selectedAgent) {
      onSave(agentsIds.filter((id) => id !== selectedAgent));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="dark:bg-boxdark rounded-md bg-white p-6 shadow-lg">
        <h3 className="mb-4 text-xl font-medium text-black dark:text-white">
          Премахни агент от {officeName}
        </h3>
        <SelectGroup
          value={selectedAgent || ""}
          placeholder="Изберете агент"
          options={agents}
          onChange={setSelectedAgent}
        />
        <div className="mt-6 flex justify-end">
          <button className="btn btn-secondary mr-4" onClick={onClose}>
            Отказ
          </button>
          <button
            className={`btn btn-primary ${
              selectedAgent &&
              "bg-primary rounded-md p-2 text-white dark:text-white"
            }`}
            onClick={handleAgentRemoval}
            disabled={!selectedAgent}
          >
            Запази
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveAgentPopup;
